/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var tmplCOCEntityEditView = require('../templates/COCEntityEditView.hbs');
var COCEntityFormView = require('./COCEntityFormView');
var SubmitEditEntity = require('../services/SubmitEditEntity');
require('../styles/COCEntityEditView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEntityEditView,

  className: 'coc-entity-edit-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    entityFormContainer: '.entity-form-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    entityFormContainer: '@ui.entityFormContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entity = this.model.get('entity');
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            link: '#coc/entity/' + entity.id + '/view',
            text: entity.name
          },
          {
            text: 'Edit Entity'
          }
        ]
      })
    );

    this.entityForm = new COCEntityFormView({
      model: new Backbone.Model({
        isReadOnly: true,
        viewMode: 'edit',
        entityTypes: this.model.get('entityTypes'),
        organizationTypes: this.model.get('organizationTypes'),
        entity: entity
      })
    });
    this.showChildView('entityFormContainer', this.entityForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var entity = self.model.get('entity');
    var formData = self.getFormData();
    formData.id = entity.id;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        SubmitEditEntity(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:coc:entity-view', entity.id);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.entityFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.entityForm.getFormData();
  }
});
